export default __webpack_public_path__ + "static/media/Monkey1.591ab387.png";